import styled from '@emotion/styled';

const Block = styled.div<{ isOpen?: boolean }>`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  background-color: rgba(21, 22, 25, 0.5);
  z-index: 10;
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  transition: 0.1s;
`;

type Props = {
  children: React.ReactNode;
  isOpen?: boolean;
};

const Dimmer = ({ children, isOpen }: Props) => (
  <Block isOpen={isOpen}>{children}</Block>
);

export default Dimmer;
